export default "__VITE_ASSET__CmbuF_wi__"